/*SUPPLIER*/
export const GET_SOCIETY = "GET_SOCIETY"
export const GET_SOCIETY_SUCCESS = "GET_SOCIETY_SUCCESS"
export const GET_SOCIETY_FAIL = "GET_SOCIETY_FAIL"
